(function () {
    document.addEventListener('DOMContentLoaded', function () {
        const body = document.body;
        document.body.addEventListener('click', function (e) {
            const trigger = e.target.closest('[data-modal-target]');
            if (!trigger) return;

            const id = trigger.getAttribute('data-modal-target');
            const modal = document.getElementById(id);

            if (!modal) return;

            modal.classList.add('is-open');
            body.classList.add('overflow--hidden');
            modal.setAttribute('aria-hidden', 'false');
            document.documentElement.classList.add('experiences--modal-open');
            e.preventDefault();
        });

        document.body.addEventListener('click', function (e) {
            const isClose = e.target.matches('[data-modal-close]') || e.target.closest('[data-modal-close]');
            const backdrop = e.target.classList && e.target.classList.contains('experiences-modal__backdrop');
            if (!isClose && !backdrop) return;

            const modal = e.target.closest('.experiences-modal') || document.querySelector('.experiences-modal.is-open');
            if (!modal) return;

            closeModal(modal);
        });

        document.body.addEventListener('click', function (e) {
            const dialog = e.target.closest('.experiences-modal__dialog');
            if (dialog) e.stopPropagation();
        });

        document.addEventListener('keydown', function (e) {
            if (e.key !== 'Escape') return;
            const open = document.querySelector('.experiences-modal.is-open');
            if (open) closeModal(open);
        });

        function closeModal(modal) {
            modal.classList.remove('is-open');
            body.classList.remove('overflow--hidden');
            modal.setAttribute('aria-hidden', 'true');
            document.documentElement.classList.remove('experiences--modal-open');
        }
    });
})();
